import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[libTourTarget]',
  standalone: true,
})
export class TourTargetDirective implements OnInit {
  @Input('libTourTarget') key!: string;

  private el = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    this.el.nativeElement.id = `tour-${this.key}`;
  }
}
